/* eslint-disable linebreak-style */
/* eslint-disable quotes */
/* eslint-disable linebreak-style */
/* eslint-disable max-len */
/* eslint-disable react/jsx-filename-extension */
import React from "react";

import Fade from "react-reveal/Fade";

import herocontact from "assets/images/contactHero.png";

export default function Herocontact() {
  return (
    <section className="hero sm:items-center lg:items-start sm:flex-row">
      <Fade bottom>
        <div className="w-full sm:w-1/2 flex flex-col px-5 mb-5 sm:mb-0 sm:px-12 sm:mt-6 lg:mt-6 xl:mt-20">
          <h1 className="text-6xl text-theme-dark-Blue font-bold leading-tight mb-5 dark:text-theme-dark-Blue">
            Lets Discuss
          </h1>
          <p className="font-light text-xl text-black leading-relaxed dark:text-white">
            Share your project with us. We will turn your idea into reality.
          </p>
        </div>
        <div className="w-full sm:w-1/2 sm:pr-12">
          <img src={herocontact} alt="Hero" />
        </div>
      </Fade>
    </section>
  );
}
